﻿window.$ = window.jQuery = require('jquery');
require('bootstrap');
require('../../../share/client/js/top.js');
require('../../../share/client/js/login.js');
require('../../../share/client/js/scrolltop.js');
require('../../../share/client/js/footer.js');
require('./top.js');

// (new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
// (new Date()).Format("yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18
window.dateFormat = function (date, fmt) {
    var o = {
        'M+': date.getMonth() + 1, // 月份
        'd+': date.getDate(), // 日
        'h+': date.getHours(), // 小时
        'm+': date.getMinutes(), // 分
        's+': date.getSeconds(), // 秒
        'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
        'S': date.getMilliseconds() // 毫秒
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    for (var k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)));
        }
    }
    return fmt;
};

window.showWait = function () {

};

window.hideWait = function () {

};

window.getdaysdiff =
    function (datetime) {
        var currentDate = Date.now();
        var day = parseInt(Math.abs(currentDate - datetime) / 1000 / 60 / 60 / 24);
        switch (day) {
        case 0:
            day = '今天';
            break;
        case 1:
            day = '昨天';
            break;
        case 2:
            day = '前天';
            break;
        default:
            day = day + '天前';
            break;
        }
        return day;
    };

window.getext = function (path) {
    var pos = path.lastIndexOf('.');
    if (pos === -1) {
        return '';
    }

    var ext = path.substr(pos + 1).toLowerCase();
    return ext;
};

window.getFileName = function (str) {
    var pos = str.lastIndexOf('.');
    if (pos == -1) {
        return str;
    }

    var name = str.substr(0, pos);
    return name;
};
window.getFileExt = function (str) {
    var pos = str.lastIndexOf('.');
    if (pos == -1) {
        return '';
    }

    var ext = str.substr(pos + 1);
    return ext;
};
window.checkstr = function (str) {
    return false;
};
window.clearstr = function (s) {
    var pattern = /[^0-9a-zA-Z\u4e00-\u9fa5]+/;
    var rs = '';
    for (var i = 0; i < s.length; i++) {
        rs = rs + s.substr(i, 1).replace(pattern, '');
    }
    return rs;
};